import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { Toast } from 'vant';
import { Dialog } from 'vant'

// 2. 引入组件样式
import 'vant/lib/index.css';
import './assets/basic.scss';

createApp(App)
  .use(store)
  .use(router)
  .use(Toast)
  .use(Dialog)
  .mount('#app');
